<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        登记资料提交
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section class="content-section">
      <div class="list-warpper">
        <div class="title">可申请企业名单</div>
        <div class="mb20">
          <span>当前申请年份：</span>
          <el-radio-group v-model="canApplyDate">
            <el-radio :label="curYear">{{ curYear }}</el-radio>
            <el-radio :label="nextYear">{{ nextYear }}</el-radio>
          </el-radio-group>
        </div>
        <div>
          <template v-for="(v, i) in corpList">
            <p class="corp-item" :key="i">
              <span>{{ v.companyName }}</span>
              <i class="el-icon-circle-close" @click="deleteCorp(v)"></i>
            </p>
          </template>
          <p class="corp-item" @click="openCorpDialog">
            <el-button type="text"
              ><i class="el-icon-plus"></i>新增企业</el-button
            >
          </p>
        </div>
      </div>
    </section>
    <section class="btn-group">
      <el-button @click="goBack()">返回</el-button>
      <el-button type="primary" @click="saveData">确 定</el-button>
    </section>
    <!-- content end -->
    <el-dialog
      title="新增企业"
      :visible.sync="dialogVisible"
      width="450px"
      @closed="handleCloseDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form :model="form" ref="corpForm">
          <el-form-item
            label="企业名称"
            prop="companyId"
            :rules="[
              { required: true, message: '请选择企业名称', trigger: 'change' },
            ]"
          >
            <e6-vr-select-linkage
              v-model="form.companyId"
              :data="noSettingCorpList"
              clearable
              @change="handleChangeCorp"
            >
            </e6-vr-select-linkage>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog">取 消</el-button>
        <el-button type="primary" @click="saveAddCorp">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { cloneDeep } from "lodash";
import {
  queryCorpList,
  getApplyCompanyList,
  deleteCorp,
  saveCorp,
} from "@/api/businessApplication";
export default {
  data() {
    return {
      canApplyDate: "",
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页",
          },
        },
        {
          path: "/truckPassRegistration",
          isRedirect: true,
          meta: {
            title: "登记资料提交",
          },
        },
      ],
      loading: false,
      corpList: [],
      // 新增企业弹框
      dialogVisible: false,
      form: {
        companyId: [],
      },
      selectCorpObj: [],
      noSettingCorpList: [],
      curYear: moment().format("YYYY"),
      nextYear: moment().add(1, "y").format("YYYY"),
    };
  },
  computed: {
    pageTitle() {
      const pageTitle = "申请权限分配";
      return pageTitle;
    },
  },
  created() {
    let breadcrumb = {
      path: "/permissionAssignment",
      isRedirect: false,
      meta: {
        title: this.pageTitle,
      },
    };
    this.breadcrumbs.push(breadcrumb);
    // 请求与申请企业数据
    this.getCorpList();
    // 获取企业下拉框
    this.applyCompanyList();
  },
  methods: {
    // 获取可申请企业数据
    async getCorpList() {
      try {
        this.loading = true;
        let { code, result } = await queryCorpList();
        if (code && result) {
          this.corpList = result;
          if (result.length) {
            this.canApplyDate = result[0].canApplyDateStr;
          } else {
            this.canApplyDate = moment().format("YYYY");
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    // 获取企业下拉框
    async applyCompanyList() {
      try {
        this.loading = true;
        let { code, result } = await getApplyCompanyList();
        if (code && result) {
          this.noSettingCorpList = result;
          this.noSettingCorpList.forEach((v) => {
            v.id = v.companyId;
            v.label = v.companyName;
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    // 选择企业数据
    handleChangeCorp(node) {
      this.selectCorpObj = this.noSettingCorpList.filter((v) => {
        return node.find((n) => n == v.companyId);
      });
    },
    // 删除企业
    async deleteCorp(data) {
      try {
        this.corpList = this.corpList.filter(
          (v) => v.companyId != data.companyId
        );
      } catch (err) {
        console.log(err);
      }
    },
    // 打开弹出框
    openCorpDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.corpForm.clearValidate();
      });
    },
    // 关闭弹出框
    handleCloseDialog() {
      this.form.companyId = [];
      this.$refs.corpForm.resetFields();
      this.$refs.corpForm.clearValidate();
      this.dialogVisible = false;
    },
    // 保存新增企业
    saveAddCorp() {
      try {
        this.$refs.corpForm.validate(async (valid) => {
          if (valid) {
            this.selectCorpObj.forEach((v) => {
              this.corpList.push({
                companyName: v.label,
                companyId: v.id,
              });
            });
            this.handleCloseDialog();
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async saveData() {
      try {
        let parmas = {
          canApplyDate: `${this.canApplyDate}-01-01`,
          canApplyCompanyVOList: cloneDeep(this.corpList),
        };
        parmas.canApplyCompanyVOList.forEach((v) => {
          v.id = v.companyId;
          v.label = v.companyName;
        });
        let { code } = await saveCorp(parmas);
        if (code) {
          this.$message.success("保存成功");
          this.goBack();
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 返回
    goBack() {
      this.$router.push({
        path: "/truckPassRegistration",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.mb20 {
  margin-bottom: 20px;
}
.content-section {
  height: calc(100% - 54px);
  overflow: auto;
  background: #fff;
  .list-warpper {
    padding: 20px;
    .title {
      margin: 20px 0;
      font-size: 20px;
      font-weight: bold;
    }
    .corp-item {
      color: #333;
      display: inline-block;
      margin-right: 20px;
      .el-icon-circle-close {
        position: relative;
        top: 2px;
        cursor: pointer;
        margin-left: 5px;
        font-size: 16px;
        color: #999;
      }
    }
  }
}
.btn-group {
  width: calc(100%);
  padding: 15px;
  text-align: center;
  position: absolute;
  bottom: 0px;
  background: #fff;
  box-shadow: 0 0 10px #eee;
}
</style>
